import React from "react";
import { dispatch } from '@rematch/core';
import { Icon, Card, Header, Container, Popup, Button } from "semantic-ui-react";
import { withRouter } from 'react-router-dom';
import InitiativeCard from './../Drive/cards/BasicCard';
import LoadingComponent from '../../../common/LoadingComponent';
import NoDataPage from "./NoDataPage";
import ArrangementPane from './ActiveInitiative/ArrangementPane';
import ReactResizeDetector from 'react-resize-detector';
import InitiativeBreadCrumbs from './../Drive/cards/Breadcrumbs'
import GroupedInitiativeCard from './../Drive/cards/GroupedInitiativeCard'
import GroupIcon from "../../../layout/header/Toolbar/Component/GroupIcon";
import capitalizeWord from '../../../../helpers/capitalizeWord'
import _ from 'lodash'

class InitiativeCardList extends React.Component {

    constructor(props) {
        super(props);
        this.parentRef = React.createRef();
        this.state = {
            order: 1
        }
    }

    componentWillMount() {
        // dispatch.initiatives.setSelectedDataById({});
        let payload = {};
        payload.organizationId = this.props.match.params.workspaceId;
        payload.accountId = this.props.match.params.accountId;
        let intitiativeData = this.props.intitiativeData;
        dispatch.initiatives.showResourecePane(null);
        dispatch.initiatives.getInitiatives(payload);
        dispatch.initiatives.getinitiativesCount(payload);

        dispatch.initiatives.setTabName("ActiveInitiative");;
        if (this.props.match.params.pageStatus !== null) {
            dispatch.initiatives.setPageStatus(null);
        }
        if (this.props.match.params.tabName !== null) {
            dispatch.initiatives.setTabName("ActiveInitiative");;
        }
        if (this.props.match.params.initiativeId !== null) {
            dispatch.initiatives.setInitiativeId(null);
        }
        if (this.props.selectedDataById && this.props.selectedDataById.createdBy) {
            dispatch.initiatives.getInitiativeOwnerDetails(this.props.selectedDataById.createdBy);
        }

        if (this.props.raciFilterProperties) {
            this.props.raciFilterProperties.raciAllChecked = true;
            this.props.raciFilterProperties.accountable = false;
            this.props.raciFilterProperties.responsible = false;
            this.props.raciFilterProperties.consulted = false;
            this.props.raciFilterProperties.informed = false;
            dispatch.initiatives.setRACIFilterProperties(this.props.raciFilterProperties);
        }

    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedDataById._id !== nextProps.selectedDataById._id) {
            if (nextProps.selectedDataById.createdBy) {
                dispatch.initiatives.getInitiativeOwnerDetails(nextProps.selectedDataById.createdBy);
            }
        }


        if (this.props.routeParams.status !== nextProps.routeParams.status) {
            dispatch.app.setRouteParams(this.props.match.params)
        }

    }

    componentDidMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        this.setState({ page: this.props.match.params.status });
        let path = this.props.match.params.status ?
                this.props.match.params.status === 'indesign' ? "0/1" :
                    this.props.match.params.status === 'active' ? "0/2" :
                        this.props.match.params.status === 'closed' ? "0/3" :
                            this.props.match.params.status === 'cancelled' ? "0/4" :
                                this.props.match.params.status === 'draft' ? "0/0" :
                                    null :
            "0"
        if (this.state.currentPath !== path) {
        dispatch.initiatives.setTreeCurrentPath(path);
        }
    }

    startCreatePlaybook() {
        // dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        // dispatch.initiatives.showResourecePane(null);
        dispatch.initiatives.setSelectedInitiative({});
        dispatch.initiatives.setSelectedDataById({});
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/selectPlaybook'
        });

    }



    groupData = (data) => {
        if (data.value === "reset") {
            dispatch.initiatives.isSortingFlag({key: "subCategory", order: -1, text: "Sub Category"  });
        } else {

            dispatch.initiatives.isSortingFlag({ key: data.value, order: data.order });
        }

        this.setState({ order: 1 })
    }

    sortByStatus = () => {
        let query = {
            organizationId: this.props.routeParams.workspaceId,
            accountId: this.props.routeParams.accountId,
        };
        if (this.props.sortingFlag) {
            // query.$sort = { [this.props.sortingFlag.value]: this.state.order };
            // query.sortBy = { key: this.props.sortingFlag.key, order: this.state.order }
            dispatch.initiatives.isSortingFlag({ key: this.props.sortingFlag.key, order: this.state.order });
        }
        else {
            query.$sort = { 'createdAt': this.state.order }
            dispatch.initiatives.isSortingFlag(null);
            dispatch.initiatives.getInitiatives(query);
        }
        //
        this.setState({ order: this.state.order === 1 ? -1 : 1 })
    }

    render() {
        let height = 500;
        let windowDimension = this.props.componentDesignerDimension;
        let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 50

        let createInitiative =
            <Card onClick={() => this.startCreatePlaybook()} className="createCard">
                <Card.Content textAlign="center">
                    <Icon name="plus" size="large" />
                    <Card.Description>Create New Initiative </Card.Description>
                </Card.Content>
            </Card>

        let loadLoader = null
        if (this.props.loadingSelectedInitiative) {
            loadLoader = <LoadingComponent active={this.props.loadingSelectedInitiative} message="Fetching Initiatives Details" />
        }

        if (this.props.loadingSelectedInitiative) {
            loadLoader = <LoadingComponent active={this.props.loadingSelectedInitiative} message="Fetching Initiatives Details" />
        }

        let indesign = this.props.intitiativeData.data && this.props.intitiativeData.data.filter((item, index) => { return item.status === 0 })
        let active = this.props.intitiativeData.data && this.props.intitiativeData.data.filter((item, index) => { return item.status === 1 || item.status === 2 || item.status === 4 })
        let closed = this.props.intitiativeData.data && this.props.intitiativeData.data.filter((item, index) => { return item.status === 3 })
        let cancelled = this.props.intitiativeData.data && this.props.intitiativeData.data.filter((item, index) => { return item.status === 5 })
        let draft = this.props.intitiativeData.data && this.props.intitiativeData.data.filter((item, index) => { return item.status === -1 })

        let initiativeCards = [];

        // if (this.props.matcjh.params.status) {
        //     dispatch.initiatives.isSortingFlag(null);
        // }

        if (this.props.match.params.status === 'indesign') {
            initiativeCards = indesign
        } else if (this.props.match.params.status === 'active') {
            initiativeCards = active
        } else if (this.props.match.params.status === 'closed') {
            initiativeCards = closed
        } else if (this.props.match.params.status === 'cancelled') {
            initiativeCards = cancelled
        } else if (this.props.match.params.status === 'draft') {
            initiativeCards = draft
        } else {
            initiativeCards = this.props.intitiativeData && this.props.intitiativeData.data
        }

        return (
            <div
                fluid
                className="pad_20"
                style={{ height: designerHeight ? designerHeight : 200 }}
                className={`${this.props.arrangementPaneTab ? "containerBox" : "containerBoxFullWidth"} overflow-hide`}
            >
                {loadLoader}
                {this.props.arrangementPaneTab ?
                    <ArrangementPane {...this.props} /> :
                    null}

                <div style={{ height: "30px" }}>
                    <div className="float-left" style={{ width: "calc(100% - 200px)" }}>
                        <InitiativeBreadCrumbs {...this.props} />
                    </div>
                    {initiativeCards &&
                        initiativeCards.length === 0 ? null :
                        <div className="float-right" style={{ width: "200px" }}>
                            <GroupIcon
                                handleSort={this.groupData}
                                page="Initiative"
                                routeParams={this.props.routeParams}
                                disabled={this.props.routeParams && this.props.routeParams.status ? true : false}
                                sortingFlag={this.props.sortingFlag}
                                InitiativeLibrary={initiativeCards}
                            />
                            <Popup
                                className="popupStyled"
                                inverted
                                trigger={<Button
                                    icon={`sort ${this.state.order === 1 ? 'amount up' : "amount down"}`}
                                    onClick={this.sortByStatus}
                                    disabled={this.props.disabled}
                                    className="float-right pad_5"
                                    size="mini"
                                />}
                                content={`Sort by ${this.props.sortingFlag && this.props.sortingFlag.key ?
                                    this.props.sortingFlag.key === "scope" ? "Library" :
                                        capitalizeWord(this.props.sortingFlag.key) : "Date"}`}
                                position="left center"
                            />
                        </div>}
                </div>
                <div className="clear-both">
                    {this.props.sortingFlag ?
                        <GroupedInitiativeCard
                            InitiativeLibrary={initiativeCards}
                            sortingFlag={this.props.sortingFlag}
                            selectedDataById={this.props.selectedDataById}
                            routeParams={this.props.routeParams}
                        />
                        :
                        <Card.Group className="playbookCardsList">
                            {this.props.match.params.status === 'indesign' ? createInitiative : null}
                            {initiativeCards &&
                                initiativeCards.length !== 0 ?
                                initiativeCards
                                    .filter(f => { return !f.copyId })
                                    .map((item, index) => {
                                        return <InitiativeCard
                                            key={index}
                                            index={index}
                                            cardData={item}
                                            id={item._id}
                                            {...this.props}
                                        />
                                    }) :
                                this.props.match.params.status === 'indesign' ? null :
                                    <NoDataPage
                                        noDataContent="No Initiatives available to display" />

                            }
                        </Card.Group >
                    }
                </div>
            </div >
        );
    }
}


export default withRouter(InitiativeCardList);
